import { Link as LinkComponent } from 'react-router-dom'
import { mkWidget } from 'widgets-for-react'
import React from 'react'

import { ButtonProps } from './widgets/featuredContentBlock.gen'
import { LinkProps } from './widgets/linkBlock.gen'
import { Link } from './types.gen'
import { acceptCookies } from './cookiebar.utils.mod'
import { t } from 'i18next'

export function jsxToWidget<a>(jsx: JSX.Element) {
  return mkWidget<a>({ run: _ => jsx })
}

export function getClassName<style>(options: { style?: style }, className: keyof style, notset: string = ''): string {
  return String(options && options.style && options.style[className] ? options.style[className] : notset)
}

export function link(link: Link, style: { classname: string }, inner: JSX.Element | string, onclick?: () => void): JSX.Element {
  return link.is_link_external || link.target === '_blank' ? (
    <a className={style.classname} target={link.target} href={link.url} onClick={onclick ? onclick : null}>
      <span className="btn__text">{inner}</span>
    </a>
  ) : (
    <LinkComponent className={style.classname} to={link.url} onClick={onclick ? onclick : null}>
      <span className="btn__text">{inner}</span>
    </LinkComponent>
  )
}

//  This function matches the url of a DrupalLink against a regex that checks if the url that we want to
//  navigat to is on the same host we are curently at, or is only a path so we can use the <Link> component
//  otherwhise, if it isnt a url on our own hostname it returns true and is external.
export function isLinkExternal(url: string): boolean {
  if (url && url.startsWith('/') && !url.startsWith(`/${window.wp.language}`)) {
    return true
  }

  return url && url.startsWith('http') && !url.startsWith(window.wp.url)
}

export function isLinkExternalDomain(url:string ): boolean {
  return (url && url.startsWith('http') && !url.startsWith(`${window.location.protocol}//${window.location.host}`))
}

export const isLinkDownload: (url: string) => boolean = (url: string) => {
  return maybeMakeRelative(url).startsWith('/uploads')
}

// Strip a Drupal link of its domain information so we only have the path left
export const stripUrlToPath = (link: { title: string; url: string }): string => {
  let a = document.createElement('a')
  a.href = link.url
  return a.pathname
}

// Create a link from an acf link that checks if it is external, and rewrites the url if needed
export const buttonWrapper = (link: { title: string; url: string }): ButtonProps<never, never> => ({
  kind: 'link',
  is_link_external: isLinkExternal(link.url),
  target: '_self',
  title: link.title,
  url: isLinkExternal(link.url) ? link.url : stripUrlToPath(link)
})

function maybeMakeRelative(url) {
  return url.replace(window.location.protocol + "//" + window.location.host, '');
}


export const linkWrapper = (link: { title: string; url: string }): Link => ({
  kind: 'link',
  is_link_external: isLinkExternal(link.url),
  target: isLinkExternalDomain(link.url) ? '_blank' : '_self',
  title: link.title,
  url: maybeMakeRelative(link.url)
})

export const parseLinkProps = (li: { title: string; url: string }, key: number): LinkProps => ({
  key: key.toString(),
  title: li.title,
  target: isLinkExternal(li.url) ? '_blank' : '_self',
  url: isLinkExternal(li.url) ? li.url : stripUrlToPath(li)
})

export const getFileType = (link: string): string => {
  let ext:string = link.split('.').pop()
  return ext;
}

export function getParameterByName(name: string): string {
  let url = window.location.href
  name = name.replace(/[\[\]]/g, '\\$&')
  let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url)
  if (!results) return ''
  if (!results[2]) return ''
  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}

export function insertUrlParam(key: string, value: string): void {
  if (history.pushState) {
    let searchParams = new URLSearchParams(window.location.search)
    searchParams.set(key, value)
    let newurl =
      window.location.protocol + '//' + window.location.host + window.location.pathname + '?' + searchParams.toString()
    window.history.pushState({ path: newurl }, '', newurl)
  }
}
export function removeUrlParams(kind: 'all' | string): void {
  if (history.pushState) {
    let newurl = window.location.protocol + '//' + window.location.host + window.location.pathname
    if (kind != 'all') {
      let searchParams = new URLSearchParams(window.location.search)
      searchParams.delete(kind)
      newurl = newurl + '?' + searchParams.toString()
    }

    window.history.pushState({ path: newurl }, '', newurl)
  }
}

export const LOCALE: string = document.documentElement.lang || 'nl'

export const dateToString = (date: Date) => 
  `${date.toLocaleString(LOCALE, {
    day: 'numeric', 
    month: 'long', 
    year: 'numeric'
  })}`

export function toMonth(str: string): string {
  let a = +str

  switch (a) {
      case 1:
          return "January"
      case 2:
          return "February"
      case 3:
          return "March"
      case 4:
          return "April"
      case 5:
          return "May"
      case 6:
          return "June"
      case 7:
          return "July"
      case 8:
          return "August"
      case 9:
          return "September"
      case 10:
          return "October"
      case 11:
          return "November"
      case 12:
          return "December"
  }
}

export const DefaultCookiePlaceHolder = () => <div className="media__placeholder">
  <div className="media__inner">
    <p>{t('cookiebar.missing')}</p>
    <p>
      <button onClick={() => acceptCookies()} className="button button--primary">{t('cookiebar.accept')}</button>
    </p>
  </div>
</div>